export const clamp = (value: number, max: number, min: number): number => {
  const fromBottom = min === undefined ? value : Math.max(value, min);
  return max === undefined ? fromBottom : Math.min(value, max);
};
